import { category_actions } from "./actionTypes";
import { apicall } from "../../services/api";
import { toast } from "react-toastify";

// Create Category
export const createCategory = (payload) => async (dispatch) => {
  try {
    dispatch({ type: category_actions.CAT_LOADING });
    const response = await apicall("/resource-category/", "post", payload);
    dispatch({ type: category_actions.CREATE_CATEGORY, payload: response.data });
    dispatch(getCategories());
    toast.success(response?.data?.message);
  } catch (error) {
    dispatch({ type: category_actions.ERR_CATEGORY, payload: error.message });
    toast.error(error?.response?.data?.message);
  }
};

// Get All Categories
export const getCategories = () => async (dispatch) => {
  try {
    dispatch({ type: category_actions.CAT_LOADING }); // ✅
    const response = await apicall("/resource-category/", "get");
    dispatch({ type: category_actions.GET_CATEGORIES, payload: response.data?.data });
  } catch (error) {
    dispatch({ type: category_actions.ERR_CATEGORY, payload: error.message });
    toast.error("Failed to fetch categories.");
  }
};

// Update Category
export const updateCategory = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: category_actions.CAT_LOADING }); // ✅
    const response = await apicall(`/resource-category/${id}/`, "patch", payload,);
    dispatch({ type: category_actions.UPDATE_CATEGORY, payload: response.data });
    dispatch(getCategories());
    toast.success(response?.data?.message);
  } catch (error) {
    dispatch({ type: category_actions.ERR_CATEGORY, payload: error.message });
    toast.error(error?.response?.data?.message);
  }
};

// Delete Category
export const deleteCategory = (id) => async (dispatch) => {
  try {
    dispatch({ type: category_actions.CAT_LOADING }); // ✅
    const res = await apicall(`/resource-category/${id}/`, "delete");
    dispatch({ type: category_actions.DELETE_CATEGORY, payload: id });
    toast.success(res?.data?.message);
  } catch (error) {
    dispatch({ type: category_actions.ERR_CATEGORY, payload: error.message });
    toast.error("Failed to delete category.");
  }
};
